export const ENVIRONMENT = 'development' // production

export const TOKEN_NAME ='token'

//export const TOKEN_NAME = ENVIRONMENT === 'production' ? '_brass_token' : '_brass_token_dev'
